// Lightweight anonymous user identity stored in localStorage.
const USER_KEY = "boardroom_user_id";
const NAME_KEY = "boardroom_user_name";

export function getUserId() {
  let id = localStorage.getItem(USER_KEY);
  if (!id) {
    id = (crypto && crypto.randomUUID ? crypto.randomUUID() : `u-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
    localStorage.setItem(USER_KEY, id);
  }
  return id;
}

export function getUserName() {
  return localStorage.getItem(NAME_KEY) || "Chair";
}

export function setUserName(name) {
  localStorage.setItem(NAME_KEY, name);
}

/**
 * Wipe the local anonymous identity so the app looks brand-new after logout.
 * The next `getUserId()` call will mint a fresh UUID. Callers should also
 * clear any React state that was derived from the previous identity.
 *
 * IMPORTANT: if you add any new per-user localStorage keys elsewhere in the
 * app, remember to clear them here too — otherwise stale user data will leak
 * across a logout boundary. Preferred pattern: prefix with "boardroom_" and
 * add to LOCAL_KEYS below.
 */
const LOCAL_KEYS = [USER_KEY, NAME_KEY];

export function resetIdentity() {
  try {
    for (const key of LOCAL_KEYS) {
      localStorage.removeItem(key);
    }
  } catch (e) {
    console.debug("resetIdentity: localStorage unavailable", e);
  }
}
